import { useContextDaysPropGetters, type DPDay } from '@rehookify/datepicker';
import calendarStyles from '~/styles/calendar/calendar.module.css';
import { DayState } from '~/hooks/calendar/useDayStateForDate';
import cnh from '~/helpers/cnh';

type Props = {
  day: DPDay;
  dayState?: DayState | null;
};

export default function Day({
  day,
  dayState = undefined,
}: Props) {
  const { dayButton } = useContextDaysPropGetters();
  const { inCurrentMonth, $date } = day;

  const isDisabled = (
    // The day is not available in the dataset from the API
    !dayState
    // The availability is not available in the dataset from the API
    || dayState?.availability === null
    // The availability is "not available" in the dataset from the API
    || dayState?.availability === 'NA'
  );

  let testId;

  if (dayState?.price) {
    testId = 'day-with-price';
  } else if (dayState?.availability === 'RQ') {
    testId = 'day-on-request';
  }

  return (
    <button
      key={$date.toString()}
      type="button"
      data-in-current-month={inCurrentMonth}
      className={cnh(
        calendarStyles.calendarDay,
        isDisabled ? calendarStyles.calendarDayDisabled : '',
        dayState?.price ? calendarStyles.calendarDayHasPrice : '',
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...dayButton(day, { disabled: isDisabled })}
      data-testid={testId}
    >
      <span>
        {parseInt(day.day, 10)}
      </span>
      {dayState?.price && (
        <span className={calendarStyles.calendarDayPrice}>
          {dayState.price}
        </span>
      )}
    </button>
  );
}
